import styled from '@emotion/styled';
import * as React from 'react';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' }) <PropsType>`
    height: auto;
`;

export const BresBetLogo = observer('BresBetLogo', ({ className, onClick }: PropsType): JSX.Element => (
    <SvgElement
        className={className}
        onClick={onClick}
        width='172'
        height='56'
        viewBox='0 0 172 56'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fill='#ED3FAA'
            d='M.896 20.65H12.85c7.174 0 10.261 2.079 10.261 6.626 0 3.464-2 5.326-5.695 6.15v.39c5 .432 6.608 1.948 6.608 5.673 0 4.33-2.782 7.146-9.956 7.146H.896V20.65Zm7.826 5.803v4.85h4c2.13 0 2.956-.649 2.956-2.467 0-1.69-.74-2.382-2.827-2.382h-4.13Zm0 10.004v4.547h5.086c1.696 0 2.478-.866 2.478-2.252 0-1.559-.522-2.295-2.609-2.295H8.721ZM37.154 38.622h-2.869v8.012h-7.826V20.65h12c6.869 0 10.695 2.901 10.695 9.137 0 3.81-1.652 6.279-4.434 7.622l5.956 8.747v.477H41.59l-4.435-8.012Zm-2.869-11.476v5.802h3.74c2.564 0 3.39-.909 3.39-2.901 0-2.122-1.086-2.902-3.52-2.902h-3.61ZM52.371 20.65h20.782v6.712H60.196v3.465h12.087v5.5H60.196v3.595h12.957v6.712H52.37V20.65ZM75.501 39.271l7.434-1.602c.566 2.554 2.61 3.464 4.957 3.464 2.087 0 3.261-.476 3.261-1.645 0-1.3-.913-2.078-5.609-2.815-7.26-1.083-9.478-3.984-9.478-8.532 0-5.24 3.653-8.141 11.26-8.141 7.61 0 10.522 3.204 11.13 7.535l-7.781 1.472c-.435-2.035-1.26-3.075-3.783-3.075-2.087 0-3.087.606-3.087 1.819 0 1.04.392 1.862 5.13 2.642 8.479 1.43 10.087 4.72 10.087 8.618 0 5.24-3.435 8.271-11.478 8.271-9 0-11.565-3.897-12.043-8.012v.001ZM101.847 20.65h11.955c7.174 0 10.261 2.079 10.261 6.626 0 3.464-1.999 5.326-5.695 6.15v.39c4.999.432 6.608 1.948 6.608 5.673 0 4.33-2.782 7.146-9.956 7.146h-13.173V20.65Zm7.826 5.802v4.85h4c2.13 0 2.956-.649 2.956-2.467 0-1.69-.739-2.382-2.827-2.382h-4.13.001Zm0 10.004v4.547h5.086c1.696 0 2.478-.866 2.478-2.252 0-1.559-.521-2.295-2.609-2.295h-4.956.001ZM127.41 20.65h20.782v6.712h-12.957v3.465h12.087v5.5h-12.087v3.595h12.957v6.712H127.41V20.65ZM149.539 20.65h21.565v7.145h-6.87v18.839h-7.826V27.795h-6.869V20.65Z'
        />
    </SvgElement>
));
